import React from "react";
import { Box, Card, Typography, Button } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./cisoDashboard.module.scss";

const deviationData = Array.from({ length: 12 }, (_, i) => ({
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][i],
  deviations: Math.max(5, 25 - i * 1.5 + Math.random() * 3),
}));

export const PolicyDeviationTrend = () => {
  return (
    <Card
      className={styles.card}
      sx={{ borderRadius: 2 }}
      variant="outlined"
      elevation={0}
    >
      <Box className={styles.sectionTitleRow}>
        <Box>
          <Typography className={styles.sectionHeading}>
            Policy Deviation Trend
          </Typography>
          <Typography className={styles.subtitle}>
            Non-compliant actions over time
          </Typography>
        </Box>
        <Button size="small" variant="outlined" className={styles.tagButton}>
          Last 30 days
        </Button>
      </Box>
      <Box height={300}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={deviationData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="month" tick={{ fontSize: 12, fill: "#64748B" }} />
            <YAxis tick={{ fontSize: 12, fill: "#64748B" }} />
            <Tooltip />
            <Bar dataKey="deviations" radius={[6, 6, 0, 0]} fill="#0CA6F2" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default PolicyDeviationTrend;
